module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/c019f6ed0fc028c1f003f1fb6eecaf8e.gif";